export default __webpack_public_path__ + "static/entertainment-video-image-interscroller-4ec787073940a34d0d2008feabac4ef1.gif";